import { Component, OnInit } from "@angular/core";
import { UserService } from "@app/core/services/user.service";
import { EntityType } from "@lib/models/entity/entity-type";

@Component({
  selector: "app-team-home",
  templateUrl: "./team-home.component.html",
  styleUrls: ["./team-home.component.scss"],
})
export class TeamHomeComponent implements OnInit {
  public entityType = EntityType.Team;
  constructor( public userService: UserService ) {}

  ngOnInit(): void {}
}
